import { enGB } from 'date-fns/locale/en-GB';
import { nb } from 'date-fns/locale/nb';

export const dateLocales = {
  EN: enGB,
  NB: nb,
};
